import { Box } from "@mui/material";
import Head from "next/head";
import { useEffect } from "react";
import Breadcrumbs from "../../../src/components/common/Breadcrumbs";
import { MemoizedFooter } from "../../../src/layouts/footer";
import { MemoizedHeader } from "../../../src/layouts/header";
import { MemoizedHappyCustomers } from "../../../src/pages/HappyCustomers/HappyCustomers";
import { sendAnalytics } from "../../../src/utils/analyticsCommon";
import BookEVConsultationForm from "../../../src/modules/Home/BookEVconsult/bookEVConsultation";

export default function HappyCustomersInfo({ customerId }) {
  const canonicalUrl = customerId
    ? `https://www.turno.club/happycustomers/${customerId}`
    : "https://www.turno.club/happycustomers";

  const BREADCRUMB_ITEMS = [
    { label: "Home", href: "/" },
    { label: "Happy Customers", href: "/happycustomers" },
    { label: `Customer ${customerId || ""}` },
  ];

  const BREADCRUMB_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.turno.club/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Happy Customers",
        item: "https://www.turno.club/happycustomers",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: `Customer ${customerId || ""}`,
        item: canonicalUrl,
      },
    ],
  };

  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: "HappyCustomers_Screen_" + `${customerId}` },
      "en"
    );
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <Head>
        <title>Happy Customer {customerId} | Turno</title>
        <link rel="canonical" href={canonicalUrl} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>
      <Box style={{ maxWidth: "480px", margin: "0px auto" }}>
        <MemoizedHeader />
        <MemoizedHappyCustomers customerId={customerId - 1} />
        <BookEVConsultationForm />
        <Box
          sx={{
            width: { xs: "100%", md: "84%" },
            margin: "20px auto",
            padding: { xs: "0 12px", md: "0" },
          }}
        >
          <Breadcrumbs items={BREADCRUMB_ITEMS} />
        </Box>
        <MemoizedFooter />
      </Box>
    </>
  );
}

export const getStaticPaths = async () => {
  // Only generate static pages for customer IDs 1-5
  const paths = [1, 2, 3, 4, 5].map((id) => ({
    params: { customerId: id.toString() },
  }));

  return {
    paths,
    fallback: false, // 404 for any other customerId
  };
};

export const getStaticProps = async (context) => {
  const customerId = parseInt(context.params?.customerId, 10);

  // Validate customer ID is between 1-5
  if (!customerId || customerId < 1 || customerId > 5 || isNaN(customerId)) {
    return {
      notFound: true,
    };
  }

  return {
    props: { customerId },
  };
};
